export default __webpack_public_path__ + "static/media/flood-area.e27be914.png";